<template>
  <div class="login-container">
    <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
      <h2>登录 KyExl 协作系统</h2>
      <el-form-item label="用户名" prop="username">
        <el-input v-model="loginForm.username" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="loginForm.password" type="password" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="loginForm.remember">记住我</el-checkbox>
      </el-form-item>
      <el-button type="primary" @click="handleLogin" class="login-button">登录</el-button>
    </el-form>
  </div>
</template>

<script>
import api from '../utils/api';

export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        remember: false
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await api.login({
              username: this.loginForm.username,
              password: this.loginForm.password
            });
            if (res.data.success) {
              localStorage.setItem('token', res.data.token);
              // 存储用户信息到 localStorage 以备不时之需
              localStorage.setItem('user', JSON.stringify(res.data.user));
              if (this.loginForm.remember) {
                localStorage.setItem('username', this.loginForm.username);
              }
              this.$store.dispatch('login', res.data.user);
              this.$router.push('/');
            } else {
              this.$message.error(res.data.message);
            }
          } catch (error) {
            this.$message.error('登录失败，请重试');
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}
.login-form {
  width: 300px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.login-button {
  width: 100%;
}
</style>
